import React, { useEffect, useState } from 'react';

import { RouteComponentProps } from 'react-router';

import { useUserOnboardingContext } from '../../../contexts/UserOnboardingContext';

import { SetPasswordView as BaseSetPasswordView } from '../../common/SetPasswordView';

import { OnboardingSetPasswordFormValue } from '../../../components';

export type SetPasswordViewProps = RouteComponentProps<{ hash?: string }> & {
  handleGoBackStep: () => void;
  handleGoNextStep: () => void;
};

export const SetPasswordView = (props: SetPasswordViewProps) => {
  const { handleGoBackStep, handleGoNextStep } = props;
  const userOnboardingContext = useUserOnboardingContext();
  const [redirectNextStep, setRedirectNextStep] = useState<boolean>(false);

  const handleSubmit = async (values: OnboardingSetPasswordFormValue) => {
    userOnboardingContext.setNewPassword(values.password);
    setRedirectNextStep(true);
  };

  useEffect(() => {
    if (redirectNextStep) {
      handleGoNextStep();
    }
  }, [redirectNextStep, handleGoNextStep]);

  if (redirectNextStep) {
    return null;
  }

  return (
    <BaseSetPasswordView
      handleSubmit={handleSubmit}
      handleGoBackStep={handleGoBackStep}
    />
  );
};
